import { useEffect, useState } from "react";
import { ShieldAlert, PauseCircle, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { useSession } from "@/context/SessionContext";
import { api, errMsg, reasonText } from "@/lib/api";
import { Button } from "@/components/ui/button";

const Bar = ({ tone, icon: Icon, children, testid }) => (
  <div data-testid={testid} className={`flex items-start sm:items-center gap-3 px-4 sm:px-8 py-3 text-sm border-b ${tone}`}>
    <Icon className="h-4 w-4 mt-0.5 sm:mt-0 shrink-0" />
    <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between">{children}</div>
  </div>
);

export const StatusBanners = () => {
  const { session, config } = useSession();
  const [ai, setAi] = useState(null);

  useEffect(() => {
    const load = () => api.get("/system/ai").then((r) => setAi(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [session.org_id]);

  const resume = async () => {
    try {
      await api.post("/system/ai/resume");
      setAi({ paused: false });
      toast.success("Translations resumed");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <>
      {(!session.can_edit) && (
        <Bar testid="suspension-banner" tone="bg-red-50 border-red-200 text-red-800" icon={ShieldAlert}>
          <span><strong>Editing is stopped.</strong> {reasonText(session.reason || (!session.access ? "no_active_plan" : null))} Spanish pages show the English site until this is fixed in Morr Access.</span>
        </Bar>
      )}
      {ai?.paused && (
        <Bar testid="ai-paused-banner" tone="bg-amber-50 border-amber-200 text-amber-900" icon={PauseCircle}>
          <span><strong>New translations are paused.</strong> The AI balance ran out. Live Spanish pages keep working; new text shows in English. {ai.emailed ? "The agency was emailed." : ""}</span>
          <Button size="sm" variant="outline" className="border-amber-400 bg-white" data-testid="resume-translations-button" onClick={resume} disabled={!session.can_edit}>Resume translations</Button>
        </Bar>
      )}
      {config?.demo_mode && (
        <Bar testid="demo-banner" tone="bg-slate-50 border-slate-200 text-slate-700" icon={FlaskConical}>
          <span>Demo mode: businesses, plan limits and word usage are simulated. Real Morr Access sign-in turns on when the app key (mak_…) is added.</span>
        </Bar>
      )}
    </>
  );
};
